<!--产品定制-我的图库-->
<template>
  <div class="image-store">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form ref="form" :model="queryParams">
        <el-form-item label="图片形状：" class="hide_input">
          <el-radio-group v-model="queryParams.rape">
            <el-radio>全部</el-radio>
            <el-radio :label="2">似方形</el-radio>
            <el-radio :label="3">横向形</el-radio>
            <el-radio :label="4">竖向形</el-radio>
            <el-radio :label="5">超横形</el-radio>
            <el-radio :label="6">超竖形</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图片格式：" class="hide_input">
          <el-radio-group v-model="queryParams.format">
            <el-radio>全部</el-radio>
            <el-radio :label="2">PNG</el-radio>
            <el-radio :label="3">JPG/JPEG</el-radio>
            <el-radio :label="4">矢量图</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="图片名称：" prop="name">
              <el-input
                size="small"
                v-model="queryParams.name"
                style="width: 220px"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="图片编号：" prop="number">
              <el-input
                size="small"
                v-model="queryParams.number"
                style="width: 220px"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="图片分类：" prop="classification">
              <!--  <el-input
                size="small"
                v-model="queryParams.classification"
                style="width: 220px"
                placeholder="请输入内容"
              ></el-input> -->
              <el-select clearable  size="small" v-model="queryParams.classification" placeholder="请选择">
                <el-option v-for="item in classifications" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="创建时间：" prop="createTime">
              <template>
                <div class="block">
                   <el-date-picker
                    size="small"
                    v-model="queryParams.time"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期" 
                  />
                  <!-- <el-date-picker v-model="queryParams.kssj" type="date" size="small" placeholder="选择日期">
                  </el-date-picker>
                  ~
                  <el-date-picker v-model="queryParams.jssj" size="small" type="date" placeholder="选择日期">
                  </el-date-picker> -->
                </div>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="20">
            <el-form-item style="text-align:right;">
              <el-button size="small" type="info" plain @click="resetForm">重置</el-button>
              <el-button size="small" type="primary" @click="loadData">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div style="border-top: 1px solid #EBEEF5; margin-top: 10px">
          <el-form-item label="排序方式:">
            <el-radio-group v-model="queryParams.sortField" class="hide_input sort-group" @change="loadData">
              <el-radio label="UPDATE_TIME">按创建时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
              <el-radio label="CREATE_TIME">按文件大小<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="form-body" v-if="queryParams.type !== 2">
      <div v-if="tableData.length > 0">
        <el-row :gutter="24">
          <el-col :span="10">
            <el-checkbox :indeterminate="isIndeterminate" v-model="isCheckAll" @change="checkAll">全选</el-checkbox>
            <el-button
              style="margin-left: 10px"
              size="small"
              type="danger"
              icon="el-icon-delete"
              @click="batchRemoveImg"
              :disabled="!checkList.length > 0"
              >批量删除</el-button
            >
            <el-button size="small" :disabled="!checkList.length > 0" type="success">更改分类</el-button>
            <el-button size="small" @click="jumpToBin">回收站 <i class="el-icon-delete"></i></el-button>
          </el-col>

          <el-col :span="5" :offset="9" style="text-align: right">
            <el-button size="small" type="success" @click="classificationVisible = true">分类管理</el-button>
            <el-button size="small" type="warning" @click="uploadVisible = true">上传图片</el-button>
          </el-col>
        </el-row>
      </div>
     
    </div>
    <div class="form-body">
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column v-if="queryParams.type !== 2" type="selection" width="55" align="center"></el-table-column>
        <el-table-column width="186px"  label="图片编号" prop="mapId"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-col style="width: 300px">
              <el-popover placement="right" :width="scope.row.picWidth" trigger="hover" :close-delay="closeDelay">
                <img
                  class="img-big"
                  width="300px"
                  height="300px"
                  :src="`${nginx}${scope.row.picUrl}`"
                  :class="parseInt(scope.row.picWidth) > parseInt(scope.row.picHeight) ? 'use-width' : 'use-height'"
                />
                <img
                  slot="reference"
                  class="img-big"
                  width="300px"
                  :src="`${nginx}${scope.row.picUrl}`"
                  :class="parseInt(scope.row.picWidth) > parseInt(scope.row.picHeight) ? 'use-width' : 'use-height'"
                />
              </el-popover>
            </el-col>
          </template>
        </el-table-column>
        <el-table-column label="图片名称">
          <template slot-scope="scope">
            <el-row type="flex" justify="space-between" style="height:40px;line-height: 40px;">
              <div>
                {{ scope.row.picName }}
              </div>
              <div>
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="
                    fileDetailInfo = scope.row;
                    fileNameVisible = true;
                  "
                ></el-button>
              </div>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column label="图片规格">
          <template slot-scope="scope">
            <div>尺寸：{{ scope.row.picWidth }} x {{ scope.row.picHeight }}</div>
            <div>形状：</div>
            <div>格式：{{ scope.row.mapFormat }}</div>
            <div>大小：{{ scope.row.fileSize }}</div>
          </template>
        </el-table-column>
        <el-table-column label="图片分类">1</el-table-column>
        <el-table-column label="出单数">2</el-table-column>
        <el-table-column label="上传者">xxx</el-table-column>
        <el-table-column label="上传时间" prop="createTime"></el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadData"
      />
    </div>

    <el-dialog :close-on-click-modal="false"   title="上传图片" :visible.sync="uploadVisible" destroy-on-close>
      <div>
        <el-form ref="uploadForm">
          <el-form-item label="图片分类：">
            <el-select clearable  v-model="uploadForm.type" placeholder="">
              <el-option v-for="item in uploadOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图片选择：">
            <el-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleChange"
              :multiple="true"
              :file-list="fileList"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                支持一次传多张图片
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="uploadVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadVisible = false" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"   title="配置分类" :visible.sync="classificationVisible" destroy-on-close>
      <div>
        <el-tree
          :data="classificationTreeData"
          show-checkbox
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="small">
                修改
              </el-button>
              <el-button type="text" size="small" @click="() => remove(node, data)">
                删除
              </el-button>
              <el-button type="text" size="small" @click="() => append(data)">
                新增
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <div slot="footer">
        <el-button @click="classificationVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="classificationVisible = false" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"   title="更新文件名" :visible.sync="fileNameVisible" destroy-on-close>
      <div>
        <el-form ref="fileNameform" :model="fileDetailInfo" label-width="80px">
          <el-form-item label="文件名">
            <el-input v-model="fileDetailInfo.picName"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="fileNameVisible = false">取 消</el-button>
        <el-button type="primary" @click="fileNameVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';
import { uploadImg, getDzMapList, removeImgs } from '@/api/procurement/all';
import * as math from 'mathjs';
import { mapGetters } from 'vuex';
export default {
  name: 'imageStore',
  components: { Breadcrumb },
  data() {
    return {
      loading: false,
      total: 0,
      form: {
        pageSize: 30,
        pageNum: 1,
        picName: undefined, //图片标题
      },
      tableData: [],
      fileList: [],
      checkList: [], //选中的图片
      isCheckAll: false,
      isIndeterminate: false,
      tempList: [],
      formData: new FormData(),
      isUpload: false,
      queryParams: { pageSize: 30, pageNum: 1 },
      classifications: [
        {
          value: '1',
          label: '分类1',
        },
        {
          value: '2',
          label: '分类2',
        },
        {
          value: '3',
          label: '分类3',
        },
      ],
      closeDelay: 0,
      uploadVisible: false,
      fileList: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
      ],
      uploadOptions: [
        {
          label: '分类1',
          value: 1,
        },
        {
          label: '分类1',
          value: 2,
        },
      ],
      uploadForm: {},
      classificationVisible: false,
      classificationTreeData: [
        {
          id: 1,
          label: '一级 1',
          children: [
            {
              id: 4,
              label: '二级 1-1',
              children: [
                {
                  id: 9,
                  label: '三级 1-1-1',
                },
                {
                  id: 10,
                  label: '三级 1-1-2',
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: '一级 2',
          children: [
            {
              id: 5,
              label: '二级 2-1',
            },
            {
              id: 6,
              label: '二级 2-2',
            },
          ],
        },
        {
          id: 3,
          label: '一级 3',
          children: [
            {
              id: 7,
              label: '二级 3-1',
            },
            {
              id: 8,
              label: '二级 3-2',
            },
          ],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      fileNameVisible: false,
      fileDetailInfo: {},
    };
  },
  computed: {
    ...mapGetters(['nginx']),
  },
  created() {
    this.loadData();
  },
  watch: {
    isUpload() {
      let that = this;
      if (this.isUpload) {
        setTimeout(() => {
          that.submitUpload();
        }, 100);
      }
    },
    checkList() {
      if (this.checkList.length == 0) {
        this.isCheckAll = false;
      }
    },
  },
  methods: {
    loadData() {
      let that = this;
      this.loading = true;
      getDzMapList(this.queryParams)
        .then((res) => {
          that.total = res.total;
          that.tableData = res.rows;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    handleChange(file, fileList) {},
    imgInfoUpload(data) {
      if (data) {
        this.isUpload = true;
      }
      this.formData.append('imageFile', data.file);
    },
    submitUpload() {
      let that = this;
      uploadImg(this.formData)
        .then((res) => {
          if (res.code == 200) {
            that.$message.success('上传成功！');
            that.loadData();
          }
          that.formData = new FormData();
          that.isUpload = false;
        })
        .catch((err) => {
          that.formData = new FormData();
          that.isUpload = false;
        });
    },
    //选中所有行
    checkAll(val) {
      this.isIndeterminate = false;
      if (val) {
        this.$refs.imgStoreTab.toggleAllSelection();
      } else {
        this.$refs.imgStoreTab.clearSelection();
      }
    },
    //行勾选事件
    handleSelectionChange(val) {
      this.isIndeterminate = val.length > 0 && val.length < this.tableData.length;
      this.isCheckAll = val.length === this.tableData.length;
      this.checkList = val;
    },
    //删除素材
    removeImg(row) {
      let that = this;
      let ids = [row.mapId];
      this.$XModal
        .confirm('您确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再想想',
        })
        .then((type) => {
          if (type == 'confirm') {
            removeImgs(ids)
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success('删除成功！');
                  that.loadData();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log('无效删除');
        });
    },
    batchRemoveImg() {
      let that = this;
      let ids = [];
      this.checkList.forEach((item) => {
        ids.push(item.mapId);
      });
      this.$XModal
        .confirm('您确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再想想',
        })
        .then((type) => {
          if (type == 'confirm') {
            removeImgs(ids)
              .then((res) => {
                if (res.code == 200) {
                  this.$message.success('删除成功！');
                  that.loadData();
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((err) => {
          console.log('无效删除');
        });
    },
    handleTypeChange(e) {
      this.loadData();
    },

    append(data) {},

    remove(node, data) {},

    turnWay(e) {
      var classVal = e.target.className;
      if (classVal == 'el-icon-caret-top') {
        e.target.setAttribute('class', 'el-icon-caret-bottom');
        this.queryParams.byAsc = 'desc';
      } else {
        e.target.setAttribute('class', 'el-icon-caret-top');
        this.queryParams.byAsc = 'asc';
      }
      this.loadData();
    },
    jumpToBin() {
      this.$router.push({
        path: '/map/map_mng/imageMe/imgRecycleBin',
      });
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
}
</style>
